import { Controller } from "@hotwired/stimulus"

// Copies the text of `source` and says so on the button for a moment:
// "Copy" becomes "Copied!" and reverts. Without the clipboard API (an
// insecure origin) the text is selected instead so it can be copied by hand.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.textContent.trim()
    try {
      await navigator.clipboard.writeText(text)
      this.flash("Copied!")
    } catch (e) {
      this.select()
    }
  }

  flash(label) {
    const button = this.buttonTarget
    const original = button.textContent
    button.textContent = label
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { button.textContent = original }, 1500)
  }

  select() {
    const range = document.createRange()
    range.selectNodeContents(this.sourceTarget)
    const selection = getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
